import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';


export default class Survey extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loadSurvey: false,
            previouslyLoaded: {
                loaded: false
            }
        }
    }

    componentDidMount(props) {
        this.setState({
            previouslyLoaded: JSON.parse(localStorage.getItem('loadedSurvey')) || this.state.previouslyLoaded
        })

    }

    componentDidUpdate(nextProps) {
        if(nextProps.loadSurvey && !this.state.previouslyLoaded.loaded) {
            this.setState({
            loadSurvey: JSON.parse(this.props.loadSurvey)
        }, this.loadSurveyMonkey(this))
        }	
    }

    handleOpen = () => { 
        this.setState({open: true});
      }

      handleClose = () => {
        this.setState({open: false});
      }

    loadSurveyMonkey = (exScope) => {
        (function(t,e,n,c){
            var o,s,p;t.SMCX=t.SMCX||[],e.getElementById(c)||(o=e.getElementsByTagName(n),s=o[o.length-1],p=e.createElement(n),p.type="text/javascript",p.async=!0,p.id=c,p.src=["https:"===location.protocol?"https://":"http://","widget.surveymonkey.com/collect/website/js/TWXGI5HyM3_2B8YfDpvbnbRWrmfKzax53EEAj1fVi7B6WUFpLpJcZXkn9GY_2BNp_2Bhrz.js"].join(""),s.parentNode.insertBefore(p,s))}
        )(window,document,"script","smcx-sdk")
        localStorage.setItem('loadedSurvey', JSON.stringify({loaded: 'true', date: new Date()}) )
    }

    render() {
        return null
    }
}
